/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { overrideForwardRef } from "../OverridableComponent";

import "./Link.scss";

export interface ILinkProps extends React.ComponentPropsWithoutRef<"a"> {
	className?: string;
	children?: React.ReactNode;
	underline?: "always" | "hover" | "none";
}

export const Link = overrideForwardRef<ILinkProps, "a">(
	({ children, className, Component, underline, ...props }, ref) => {
		const baseClass = BEM("edt-link", null, {
			underline
		});

		if (className) {
			baseClass.add(className);
		}

		return (
			<Component className={baseClass.toClassName()} {...props} ref={ref}>
				{children}
			</Component>
		);
	}
);

Link.defaultProps = {
	Component: "a",
	underline: "always"
};
